module.exports = __webpack_public_path__ + "img/wlzx.af5894a6.png";